module.exports = __webpack_public_path__ + "./fonts/3a96f9b08172480d5f87c916f84bfef6.woff2";